/* eslint-disable react/prop-types  */
/** @jsx createElement */
// noinspection ES6UnusedImports
import { createElement } from '../../jsx';
import InputSelect from './InputSelect';

const toggleCustomFieldsVisibility = (event) => {
  const targetId = event.target.value;
  event.target.closest('.guuruForm')
    .querySelectorAll('div[data-target]')
    .forEach((formControl) => {
      const disabled = formControl.dataset.target !== targetId;
      const field = formControl.closest('.embeddedServiceSidebarFormField');
      if (disabled) {
        field.style.display = 'none';
      } else {
        field.style.display = 'block';
      }
      formControl.querySelectorAll('input,select')
        // eslint-disable-next-line no-param-reassign
        .forEach((input) => { input.disabled = disabled; });
    });
};

const TransferTargets = function ({ transferTargets, translations }) {
  return transferTargets ? (
    <InputSelect
      id="transfer-target"
      name={translations.selectTargetSmartForm}
      defaultValue={transferTargets[0].id}
      options={transferTargets.map(({ id, title }) => ({
        label: title, value: id,
      }))}
      onChange={(event) => toggleCustomFieldsVisibility(event)}
      required
    />
  ) : undefined;
};

export default TransferTargets;
